export enum MenuType {
    FOOTER = "FOOTER", 
    HEADER = "HEADER"
}

export enum MenuItemsType {
    LINK = "LINK", 
    LIST = "LIST"
}

export class MenuRequest{
    externalLink: string;
    index: number;
    menuItemsType: MenuItemsType
    title: string;
    type: MenuType;
}

export class MenuRequestList{
    dimPagina: number;
    numeroPagina: number;
    
}

export class MenuRequestCreate extends MenuRequest{
    constructor(){super();}
}

export class MenuRequestUpdate extends MenuRequest{
    constructor(){super();}
}

export class MenuRequestAddMenuItems{
    id:number;
    idsMenuItems : number[];
    
}

export class MenuRequestPublish{
    id:number;
    published:boolean;
    
}

export class MenuRequestRemoveMenuItems{
    id:number;
    idsMenuItems : number[];
    
}

export class MenuRequestSearch{
    menuItemsType: MenuItemsType
    pageNumber: number;
    pageSize: number;
    published: boolean;
    sortBy: string;
    title: string;
    type: MenuType;
}